import React from "react";
import {Row} from "react-foundation";
import PropTypes from "prop-types";
import {v4 as uuidv4} from "uuid";
import classnames from "classnames";
import {addLabelToOptionsIfNotExist} from "../../utils/maybeAddLabelToOptions";
import SelectDropdown from "../Components/Dropdowns/SelectDropdown";
import {convertLabelTextToDataTestId} from "../../utils/convertLabelTextToDataTestId";

export const OptionPropType = PropTypes.shape({
    label: PropTypes.node.isRequired,
    value: PropTypes.string.isRequired
})

const OptionalDropDown = ({
                              onCheckBoxChange,
                              onDropDownChange,
                              checkBoxIsChecked,
                              checkboxText,
                              labelText,
                              helpText,
                              dropDownValues,
                              selectedDropDownValue,
                              optionalClassName,
                              id,
                              placeholder = "Select..."
                          }) => {
    const checkBoxId = `checkbox-${uuidv4()}`;

    const checkBoxChange = (isChecked) => {
        onCheckBoxChange(isChecked)
        if (!isChecked) {
            onDropDownChange(undefined)
        }
    }
    return (
        <Row>
            <div className="checkbox-container scaffolding-dag" data-testid={'checkbox_container'}>
                <input className="checkbox test"
                       type="checkbox"
                       id={checkBoxId}
                       checked={checkBoxIsChecked}
                       onChange={() => checkBoxChange(!checkBoxIsChecked)}
                />
                <label className={'checkbox-label'}
                       htmlFor={checkBoxId} data-testid={'checkbox_label'}>{checkboxText}</label>
            </div>
            <SelectDropdown
                id={convertLabelTextToDataTestId(labelText, undefined, "_dropdown")}
                dataTestId={"id-input"}
                inputLabel={labelText}
                placeholder={placeholder}
                className={classnames("optional-dropdown", optionalClassName)}
                selectValue={selectedDropDownValue?.value}
                selectLabel={selectedDropDownValue?.label}
                options={addLabelToOptionsIfNotExist(dropDownValues)}
                onChange={(option) => onDropDownChange(option ? option.value : undefined)}
                isDisabled={!checkBoxIsChecked}
            />
            <div className="help-text" data-testid={'help_text'}>{helpText}</div>
        </Row>
    );
}

OptionalDropDown.propTypes = {
    onCheckBoxChange: PropTypes.func.isRequired,
    onDropDownChange: PropTypes.func.isRequired,
    checkBoxIsChecked: PropTypes.bool.isRequired,
    dropDownValues: PropTypes.oneOfType([
        PropTypes.arrayOf(OptionPropType),
        PropTypes.arrayOf(PropTypes.string),
        PropTypes.array
    ]).isRequired,
    selectedDropDownValue: PropTypes.object,
    checkboxText: PropTypes.string,
    labelText: PropTypes.string,
    helpText: PropTypes.string,
    optionalClassName: PropTypes.string,
    placeholder: PropTypes.string,
}

export default OptionalDropDown